import { portalAction, portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../app/telemetry/usePortalTelemetry';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material"

interface Props {
    showDialog: boolean;
    closeButtonClick?: () => void;
    title: string;
    description: string;
}

export default function RestrictCpdUpdateDialog(props: Props) {
    const { showDialog, closeButtonClick, title, description } = props;

    usePortalScreen(portalScreenContext('RestrictCpdUpdateDialog'), undefined, true);

    return <Dialog open={showDialog} aria-labelledby="unsaved-changes-dialog" aria-describedby="unsaved-changes-dialog">
        <DialogTitle id="unsaved-changes-dialog">
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="unsaved-changes-dialog">
                {description}
            </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
            <Button variant="contained" color="primary"
                onClick={portalAction(portalScreenContext('RestrictCpdUpdateDialog'), 'RestrictCpdUpdateDialog.onClick.closeButtonClick', closeButtonClick)} autoFocus>
                Close
            </Button>
        </DialogActions>
    </Dialog>
}
